import IndustryDetailPage from "@/pages/industries/components/IndustryDetailPage";

export default function MediaEntertainmentPage() {
  return <IndustryDetailPage slug="media-entertainment" />;
}